import { Link } from "react-router-dom";
import { PrepChecklist } from "@/components/PrepChecklist";
import { MemberSavings } from "@/components/booking/MemberSavings";
import { doneMessage } from "@/components/booking/bookingHelpers";

export function BookingDone({ done, tier, slot }) {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16" data-testid="booking-done">
      <div className="dg-card rounded-2xl p-8 text-center">
        <div className="dg-eyebrow">Booked</div>
        <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold font-display">You're on David's calendar.</h1>
        <p className="text-slate-300 mt-3">Booking <span className="font-mono text-cyan-300">{done.booking_id}</span> · {tier.title} · {slot.label} Pacific.</p>
        <p className="text-slate-300 mt-2">{doneMessage(done)}</p>
        <MemberSavings tierName={done.member_tier_name} saved={done.member_saved_usd} savedMonth={done.member_saved_month_usd} />
        <Link to={`/book/confirmed/${done.public_token}`} className="dg-btn-primary rounded-full px-6 py-3 text-sm inline-flex mt-6" data-testid="booking-view-btn">View booking details</Link>
      </div>
      <div className="mt-8"><PrepChecklist /></div>
    </div>
  );
}
